/**
 * EmailTemplateStore — CRUD for resume-email-templates collection.
 *
 * Each template:
 * {
 *   name, subject, body,
 *   ccList: ['email1@...', 'email2@...'],
 *   targetDisposition: 'contact-1st' | 'waiting-1st' | etc.,
 *   createdAt, createdBy, updatedAt
 * }
 *
 * Body supports placeholders: {{firstName}}, {{name}}, {{email}},
 * {{interviewDate}}, {{education}}, {{skills}}
 */
export class EmailTemplateStore {
    constructor(db) {
        this._db = db;
        this._collection = db.collection('resume-email-templates');
        this._unsub = null;
        this._templates = [];
        this._listeners = [];
    }

    subscribeAll() {
        this._unsub = this._collection
            .orderBy('createdAt', 'asc')
            .onSnapshot(snap => {
                this._templates = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                this._notify();
            }, err => {
                console.error('EmailTemplateStore subscription error:', err);
            });
    }

    onChange(fn) { this._listeners.push(fn); }
    getAll() { return this._templates; }
    getById(id) { return this._templates.find(t => t.id === id) || null; }

    async create(data, createdBy) {
        const ref = await this._collection.add({
            name: data.name || 'Untitled',
            subject: data.subject || '',
            body: data.body || '',
            ccList: data.ccList || [],
            targetDisposition: data.targetDisposition || '',
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            createdBy,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        return ref.id;
    }

    async update(id, fields) {
        await this._collection.doc(id).update({
            ...fields,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
    }

    async remove(id) {
        await this._collection.doc(id).delete();
    }

    dispose() {
        if (this._unsub) this._unsub();
    }

    _notify() {
        for (const fn of this._listeners) fn(this._templates);
    }
}
